/**
 * Per-tab baseline (sessionStorage) vs latest known server version
 * (localStorage / socket / API header). Used by the post-deploy refresh snackbar.
 */

export const DASHBOARD_VERSION_BASELINE_KEY = 'dashboard-version';
export const DASHBOARD_VERSION_LATEST_KEY = 'latest-dashboard-version';

export function parseVersion(value, fallback = 0) {
  const n = parseInt(value ?? String(fallback), 10);
  return Number.isNaN(n) ? fallback : n;
}

/**
 * @param {{ getBaseline?: () => string|null, getLatest?: () => string|null }} [stores]
 * @returns {boolean}
 */
export function isDashboardOutdated(stores = {}) {
  try {
    const getBaseline =
      stores.getBaseline ??
      (() =>
        typeof sessionStorage !== 'undefined'
          ? sessionStorage.getItem(DASHBOARD_VERSION_BASELINE_KEY)
          : null);
    const getLatest =
      stores.getLatest ??
      (() =>
        typeof localStorage !== 'undefined'
          ? localStorage.getItem(DASHBOARD_VERSION_LATEST_KEY)
          : null);

    const current = parseVersion(getBaseline(), 0);
    const latest = parseVersion(getLatest(), 0);
    return latest > current;
  } catch {
    return false;
  }
}
